import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

export function Property({ label, children, ...rest }) {
  return (
    <Stack direction="row" spacing={1} {...rest}>
      <Typography sx={{ color: 'text.secondary', minWidth: 80 }}>{label}</Typography>
      {typeof children === 'string' ? <Typography>{children}</Typography> : children}
    </Stack>
  )
}

Property.Loading = function ({ width }) {
  return (
    <Property label={<Skeleton width={70} />}>
      <Typography sx={{ width: '100%' }}>
        <Skeleton width={width} />
      </Typography>
    </Property>
  )
}

export function PropertyIcon({ icon: Icon, label, children, ...rest }) {
  return (
    <Stack {...rest}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Icon sx={{ fontSize: 16 }} />
        <Typography variant="body2" sx={{ color: 'text.secondary', textTransform: 'uppercase' }}>
          {label}
        </Typography>
      </Stack>
      {typeof children === 'string' ? <Typography>{children}</Typography> : children}
    </Stack>
  )
}

PropertyIcon.Loading = function ({ width = 120 }) {
  return (
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Skeleton variant="circular" width={16} height={16} />
        <Typography variant="caption">
          <Skeleton width={60} />
        </Typography>
      </Stack>
      <Typography variant="body2">
        <Skeleton width={width} />
      </Typography>
    </Stack>
  )
}
